export const combineValidators =
  (...validators: any) =>
  (...args: any) => {
    return validators.reduce((error: any, validator: any) => error || validator(...args), undefined);
  };
